<template>
  <b-sidebar
    id="add-new-template-sidebar"
    :visible="isAddNewTemplateSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-template-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">Add New Template</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <!-- Name -->
          <validation-provider #default="validationContext" name="Template Name" rules="required">
            <b-form-group label="Template Name" label-for="template-name">
              <b-form-input
                id="template-name"
                v-model="templateData.name"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="CompTIA Security+"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Funding Sources -->
          <validation-provider #default="validationContext" name="Funding Sources" rules="required">
            <b-form-group label="Funding Sources" label-for="fundingSources" :state="getValidationState(validationContext)">
              <v-select
                v-model="templateData.fundingSources"
                :options="fundingSourceOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                :multiple="true"
                input-id="template-fundingSources"
                placeholder="Select Funding Sources"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Status -->
          <validation-provider #default="validationContext" name="Status" rules="required">
            <b-form-group label="Status" label-for="status" :state="getValidationState(validationContext)">
              <v-select
                v-model="templateData.status"
                :options="statusOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                input-id="template-status"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit"> Add </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary" @click="hide"> Cancel </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref } from '@vue/composition-api';
import { required, alphaNum, email } from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import countries from '@/libs/data/countries';
import store from '@/store';

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewTemplateSidebarActive',
    event: 'update:is-add-new-template-sidebar-active',
  },
  props: {
    isAddNewTemplateSidebarActive: {
      type: Boolean,
      required: true,
    },
    fundingSourceOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
    };
  },
  setup(props, { emit }) {
    const blankTemplateData = {
      name: '',
      fundingSources: [],
      status: 'created',
    };

    const templateData = ref(JSON.parse(JSON.stringify(blankTemplateData)));
    const resettemplateData = () => {
      templateData.value = JSON.parse(JSON.stringify(blankTemplateData));
    };

    const onSubmit = () => {
      console.log(`creating template`, templateData.value);
      store.dispatch('receivableStoreModule/addTemplate', { templateData: templateData.value }).then(() => {
        emit('refetch-data');
        emit('update:is-add-new-template-sidebar-active', false);
      });
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(resettemplateData);

    return {
      templateData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
#add-new-template-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
